import React, { forwardRef, useEffect } from "react";
import Button from "@components/_Revamp/Button";
import { styled } from "@linaria/react";
import { useHistory } from "react-router-dom";
import Link from "@components/_Revamp/Link";
import { ROUTE_PATH } from "@static/route-paths";
import MainContainer from "@pages/EverGreen/Components/Container";
import { SCREEN_SIZE } from "@static/screen-size";
import { HOME_URL } from "@static/config";
import { EverGreenStyle } from "@utils/Style/everGreen";

const SubmitSuccessWraper = styled.div`
  width: 100%;
  height: calc(100vh - 150px);
  position: relative;
`;

const SubmitSucessContainer = styled.div`
  /* max-width: 792px; */
  /* margin: 150px auto 0 auto; */
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 64px;
  position: relative;
  z-index: 1;
  margin-top: 150px;
`;

interface TextProps {
  color?: string;
  fSize?: string;
  weight?: number;
  margin?: string;
}

const Text = styled.div<TextProps>`
  color: ${(props) => (props.color ? props.color : "#434343")};
  font-weight: ${(props) => (props.weight ? props.weight : 600)};
  font-size: ${(props) => (props.fSize ? props.fSize : "16px")};
  margin: ${(props) => (props.margin ? props.margin : "0")};
  letter-spacing: 0.04em;
  font-family: "Open Sans";
  text-align: center;
  white-space: break-spaces;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    text-align: left;
    white-space: inherit;
  }
`;

export interface SubmitSuccessProps {}

export const SubmitSuccess = forwardRef<HTMLDivElement, SubmitSuccessProps>(
  (props: SubmitSuccessProps, ref) => {
    const backtoHome = () => {
      window.location.href = ROUTE_PATH.EVER_GREEN_LANDING_PAGE;
    };

    return (
      <MainContainer>
        <SubmitSucessContainer ref={ref}>
          <Text fSize="28px" weight={600}>
            Thanks for reaching out, we&apos;ll be in touch soon
          </Text>
          <Text color="#8A8988" margin={"-40px auto 0"}>
            Meanwhile, you can also reach us at {"\n"}
            <Link
              text="+65 6827 9933"
              variant="link"
              url="tel:+6568279933"
              fontSize={16}
              fontSizeTablet={16}
              underline={true}
              theme={EverGreenStyle}
            />{" "}
            or{" "}
            <Link
              text="cs_life@singlife.com"
              variant="link"
              target="_blank"
              rel="noopener noreferrer"
              url="mailto:cs_life@singlife.com"
              fontSize={16}
              fontSizeTablet={16}
              underline={true}
              theme={EverGreenStyle}
            />
          </Text>
          <Button
            label="Back to home"
            width="285px"
            onClick={backtoHome}
            theme={EverGreenStyle}
          />
        </SubmitSucessContainer>
      </MainContainer>
    );
  }
);
